import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  Image,
  Grid
} from '@chakra-ui/react'

//  Modal para confirmar el eliminar una actividad
const DeleteModal = ({ isOpen, onClose, handleDelete, selected }) => {
  const deleteActivity = () => {
    handleDelete()
    onClose()
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Text align="center" fontWeight={'bold'}>
            ¿Esta seguro de eliminar actividad {selected.description}?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            align="center"
            bg="#F2F1FB"
            color="#59BABA"
            mr={5}
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            align="center"
            bg={'teal.500'}
            color={'white'}
            _hover={{
              bg: 'teal.600'
            }}
            onClick={deleteActivity}
          >
            Eliminar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default DeleteModal
